import { render, staticRenderFns } from "./IconLogoSearchieCopilot.vue?vue&type=template&id=6ce7d5e7&"
import script from "./IconLogoSearchieCopilot.vue?vue&type=script&lang=js&"
export * from "./IconLogoSearchieCopilot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce7d5e7')) {
      api.createRecord('6ce7d5e7', component.options)
    } else {
      api.reload('6ce7d5e7', component.options)
    }
    module.hot.accept("./IconLogoSearchieCopilot.vue?vue&type=template&id=6ce7d5e7&", function () {
      api.rerender('6ce7d5e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLogoSearchieCopilot.vue"
export default component.exports